import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { AppDispatch } from 'app/store';
import { fetchUpcomingInvoice, fetchUpcomingInvoiceForSubscription } from 'api/billing/invoices';
import { IFetchUpcomingInvoiceParams, IUpcomingInvoice } from './upcomingInvoiceTypes';

export const getUpcomingInvoice = createAsyncThunk<
  IUpcomingInvoice,
  IFetchUpcomingInvoiceParams,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@upcomingInvoice/getUpcomingInvoice', async (model, thunkApi) => {
  try {
    const res =  await fetchUpcomingInvoice(model);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const getUpcomingInvoiceForSubscription = createAsyncThunk<
  IUpcomingInvoice,
  { subscriptionId: string, priceId: string, quantity: number},
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@upcomingInvoice/getUpcomingInvoiceForSubscription', async ({ subscriptionId, priceId, quantity }, thunkApi) => {
  try {
    const res =  await fetchUpcomingInvoiceForSubscription(subscriptionId, priceId, quantity);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});